import clsx from 'clsx';
import React from 'react';

interface SectionProps extends React.ComponentPropsWithoutRef<'section'> {
  className?: string;
}
// TODO: DARK MODE STYLES all discrete control and info display groups should use this component
export function Section({ className, children, ...props }: SectionProps) {
  return (
    <section
      {...props}
      className={clsx(
        'tw:bg-white tw:rounded-lg tw:border tw:border-zinc-200 tw:p-6 tw:mb-4 tw:dark:bg-zinc-600 tw:dark:border tw:dark:border-zinc-400',
        className
      )}
    >
      {children}
    </section>
  );
}

export default Section;
